/******/ (() => {
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.productSection = null;
    this.formContainer = null;        // product form ka wrapper
    this.mutationObserver = null;
    this.mainAddToCartButton = null;
    this.stickyButton = null;
    this.hideTimeout = null;
    this.scrollOffset = 350;

    this.handleStickyClick = this.handleStickyClick.bind(this);
    this.handleMutation = this.handleMutation.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    // Animation fix (pehle jaisa hi)
    this.productSection = document.querySelector('.product-section');
    if (this.productSection) {
      setTimeout(() => {
        this.productSection.style.animationName = 'none';
        this.productSection.classList.remove('show-on-scroll');
        this.productSection.classList.add('animated', 'fadeIn', 'shown-on-scroll');
      }, 1000);
    }

    // Sticky button setup
    this.stickyButton = this.querySelector('.sticky-scroll-btn') || this.querySelector('button[name="add"]');
    if (this.stickyButton) {
      this.stickyButton.setAttribute('type', 'button');
      this.stickyButton.removeAttribute('name');
      this.stickyButton.addEventListener('click', this.handleStickyClick, true);
    }

    // Product form ka container dhundho (jisme add to cart button rahega)
    // Har theme me alag ho sakta hai, yahan common selectors diye hain
    this.formContainer = document.querySelector('.product-form__buttons') 
                      || document.querySelector('.product-form') 
                      || document.querySelector('form[action*="/cart/add"]')
                      || document.querySelector('.product-section form');

    // Pehla main button set karo
    this.updateMainButton();
    if (this.mainAddToCartButton) {
      this.observeMainButton();
    }

    // MutationObserver se product form mein changes track karo
    if (this.formContainer) {
      this.mutationObserver = new MutationObserver(this.handleMutation);
      this.mutationObserver.observe(this.formContainer, {
        childList: true,
        subtree: true
      });
    }

    // Fallback: Shopify ka 'variant:change' event bhi sun lo
    document.addEventListener('variant:change', () => {
      // Thoda delay do taki DOM update ho jaye
      setTimeout(() => this.refreshMainButton(), 50);
    });
  }

  // Naya main button dhundh kar setup kare
  updateMainButton() {
    const oldButton = this.mainAddToCartButton;
    // Sirf sticky-add-to-cart ke bahar wala button
    const newButton = Array.from(document.querySelectorAll('button[name="add"]'))
      .find(btn => !btn.closest('sticky-add-to-cart'));

    if (newButton !== oldButton) {
      // Purana unobserve
      if (this.observer && oldButton) {
        this.observer.unobserve(oldButton);
      }
      this.mainAddToCartButton = newButton;
      if (newButton) {
        this.observeMainButton();
        // Turant check karo ki sticky bar dikhana hai ya nahi
        this.checkVisibility();
      }
    }
  }

  observeMainButton() {
    if (!this.mainAddToCartButton) return;
    if (!this.observer) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.hide();
            } else {
              this.show();
            }
          });
        },
        { threshold: 0, rootMargin: '0px' }
      );
    }
    this.observer.observe(this.mainAddToCartButton);
  }

  // IntersectionObserver ke alawa manually bhi check kar sakte hain
  checkVisibility() {
    if (!this.mainAddToCartButton) return;
    const rect = this.mainAddToCartButton.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  // MutationObserver callback
  handleMutation(mutations) {
    // Sirf tab refresh karein jab button badla ho
    this.updateMainButton();
  }

  // Bahari call ke liye refresh
  refreshMainButton() {
    this.updateMainButton();
  }

  handleStickyClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!this.mainAddToCartButton) return;

    const targetTop =
      this.mainAddToCartButton.getBoundingClientRect().top + window.scrollY - this.scrollOffset;

    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }

  show() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    this.classList.remove('is-hiding');
    this.classList.add('is-visible');
  }

  hide() {
    if (!this.classList.contains('is-visible')) return;
    this.classList.remove('is-visible');
    this.classList.add('is-hiding');
    this.hideTimeout = setTimeout(() => {
      this.classList.remove('is-hiding');
      this.hideTimeout = null;
    }, 300);
  }

  cleanup() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
    if (this.stickyButton) {
      this.stickyButton.removeEventListener('click', this.handleStickyClick, true);
    }
    this.mainAddToCartButton = null;
    this.stickyButton = null;
    this.productSection = null;
    this.formContainer = null;
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
})();